import { render } from "./datetime.vue?vue&type=template&id=5e7cfd88&scoped=true"
import script from "./datetime.vue?vue&type=script&lang=js"
export * from "./datetime.vue?vue&type=script&lang=js"

import "./datetime.vue?vue&type=style&index=0&id=5e7cfd88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e7cfd88"

export default script